import { components, type GroupBase, type OptionProps } from 'react-select';

import { Pill } from '../../../../generic';

import styles from './TeamMembersTable.module.less';

export type AddableUser = { label: string; value: number; isServiceAccount: boolean; };

type AddUserOptionProps = OptionProps<
  AddableUser, true, GroupBase<AddableUser>
>;

export const AddUserOption = (props: AddUserOptionProps) => {
  const { data } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Option {...props}>
      <div className={styles.username}>
        {data.label}
        {data.isServiceAccount && <Pill color="blue">Service Account</Pill>}
      </div>
    </components.Option>
  );
};
